// TR content translations. Keyed `<type>.<id>.<field>`. From content-i18n workflow.
export const contentTr: Record<string, string> = {
  "card.trade-routes.name": "Ticaret Yolları",
  "card.trade-routes.desc": "Tüm kaynak üretiminde +%25.",
  "card.sharpened-tools.name": "Bilenmiş Aletler",
  "card.sharpened-tools.desc": "+%35 hasat hasarı.",
  "card.wide-survey.name": "Geniş Keşif",
  "card.wide-survey.desc": "+%20 hasat çemberi yarıçapı.",
  "card.guild-labor.name": "Lonca İşçiliği",
  "card.guild-labor.desc": "+%45 otomatik toplama hızı.",
  "card.efficient-masons.name": "Verimli Taş Ustaları",
  "card.efficient-masons.desc": "Binalar %15 daha ucuz.",
  "card.standing-army.name": "Daimi Ordu",
  "card.standing-army.desc": "+%40 savunma ve +10 sabit savunma.",
  "card.stone-walls.name": "Taş Duvarlar",
  "card.stone-walls.desc": "+22 sabit savunma.",
  "card.drilled-ranks.name": "Talimli Birlikler",
  "card.drilled-ranks.desc": "+%20 savunma ve +8 sabit savunma.",
  "card.war-economy.name": "Savaş Ekonomisi",
  "card.war-economy.desc": "+%50 savunma.",
  "card.watchtowers.name": "Gözetleme Kuleleri",
  "card.watchtowers.desc": "+%15 savunma ve +%12 üretim.",
  "card.scholars.name": "Alimler",
  "card.scholars.desc": "+%45 bilgi üretimi ve teknoloji.",
  "card.scientific-method.name": "Bilimsel Yöntem",
  "card.scientific-method.desc": "+%25 bilgi ve +%15 üretim.",
  "card.enlightenment.name": "Aydınlanma",
  "card.enlightenment.desc": "+%30 bilgi ve +%12 savunma.",
  "card.mass-schooling.name": "Kitlesel Eğitim",
  "card.mass-schooling.desc": "+%25 bilgi ve +%20 otomatik toplama.",
  "card.engineering.name": "Mühendislik",
  "card.engineering.desc": "+%20 üretim ve binalar %10 daha ucuz.",
  "synergy.industrial-revolution.name": "Sanayi Devrimi",
  "synergy.industrial-revolution.desc": "İki ekonomi yolu birleşir: +%50 üretim.",
  "synergy.fortress.name": "Kale",
  "synergy.fortress.desc": "İki askeri yol birleşir: +%45 savunma ve +25 sabit.",
  "synergy.great-library.name": "Büyük Kütüphane",
  "synergy.great-library.desc": "İki bilgi yolu birleşir: +%60 bilgi ve +%25 üretim.",
  "synergy.renaissance.name": "Rönesans",
  "synergy.renaissance.desc": "Ekonomi ve bilgi buluşur: +%30 üretim ve +%30 bilgi.",
  "synergy.war-machine.name": "Savaş Makinesi",
  "synergy.war-machine.desc": "Ekonomi ve ordu buluşur: +%20 savunma ve +%25 üretim.",
  "synergy.enlightened-guard.name": "Aydınlanmış Muhafız",
  "synergy.enlightened-guard.desc": "Bilgi ve ordu buluşur: +%20 savunma ve +%30 bilgi.",
  "synergy.golden-age.name": "Altın Çağ",
  "synergy.golden-age.desc": "Üç yön de dengede: +%35 üretim ve bilgi, +%20 savunma.",
  "skill.bountiful-start.name": "Bereketli Başlangıç",
  "skill.bountiful-start.desc": "Her oyuna daha fazla odun, taş ve cevherle başla.",
  "skill.settlers.name": "Yerleşimciler",
  "skill.settlers.desc": "Her oyuna ek nüfusla başla.",
  "skill.industrious.name": "Çalışkan",
  "skill.industrious.desc": "Seviye başına +%8 küresel üretim.",
  "skill.sharp-tools.name": "Keskin Aletler",
  "skill.sharp-tools.desc": "Seviye başına +%10 hasat hasarı.",
  "skill.wide-reach.name": "Geniş Erişim",
  "skill.wide-reach.desc": "Seviye başına +%10 hasat çemberi yarıçapı.",
  "skill.fortified.name": "Tahkimli",
  "skill.fortified.desc": "Seviye başına +%12 yerleşim savunması.",
  "skill.swift-hands.name": "Hızlı Eller",
  "skill.swift-hands.desc": "Seviye başına +%10 otomatik toplama.",
  "skill.long-memory.name": "Uzun Hafıza",
  "skill.long-memory.desc": "Seviye başına +1 saat çevrimdışı limit.",
  "skill.war-chest.name": "Savaş Hazinesi",
  "skill.war-chest.desc": "Her oyuna teknolojiye harcayacak ganimetle başla.",
  "skill.archivist.name": "Arşivci",
  "skill.archivist.desc": "Seviye başına +%10 bilgi ve teknoloji savunması.",
  "skill.master-mason.name": "Usta Taş Ustası",
  "skill.master-mason.desc": "Seviye başına binalar %5 daha ucuz.",
  "tech.irrigation.name": "Sulama",
  "tech.irrigation.desc": "+%30 üretim.",
  "tech.masonry.name": "Taş İşçiliği",
  "tech.masonry.desc": "Binalar %20 daha ucuz.",
  "tech.cartography.name": "Haritacılık",
  "tech.cartography.desc": "+%30 hasat yarıçapı ve +%25 hasat hasarı.",
  "tech.logistics.name": "Lojistik",
  "tech.logistics.desc": "+%75 otomatik toplama.",
  "tech.conscription.name": "Zorunlu Askerlik",
  "tech.conscription.desc": "+%45 savunma.",
  "tech.bulwark.name": "Siper",
  "tech.bulwark.desc": "Boss hazırlığı: +%35 savunma ve +40 sabit savunma.",
  "tech.surge.name": "Üretim Patlaması",
  "tech.surge.desc": "25 saniye boyunca +%150 üretim. Tekrarlanabilir.",
  "artifact.double-harvest.name": "İkiz Orak",
  "artifact.double-harvest.desc": "Hasat verimini ikiye katlar ve +%50 hasat hasarı.",
  "artifact.aegis.name": "Aegis Çekirdeği",
  "artifact.aegis.desc": "Yerleşim savunmasını ikiye katlar.",
  "artifact.resource-magnet.name": "Mıknataş Taşı",
  "artifact.resource-magnet.desc": "+%60 üretim ve +%50 otomatik toplama.",
  "artifact.chronosphere.name": "Kronosfer",
  "artifact.chronosphere.desc": "Dalgalar arasında +%50 daha fazla süre.",
  "artifact.philosophers-stone.name": "Felsefe Taşı",
  "artifact.philosophers-stone.desc": "Bilgiyi ikiye katlar ve +%30 üretim.",
  "building.house.name": "Ev",
  "building.house.desc": "Yerleşimcileri barındırır, nüfusu ve iş gücünü artırır.",
  "building.lumberCamp.name": "Kereste Kampı",
  "building.lumberCamp.desc": "Otomatik olarak kereste keser.",
  "building.quarry.name": "Taş Ocağı",
  "building.quarry.desc": "Otomatik olarak taş çıkarır.",
  "building.mine.name": "Maden",
  "building.mine.desc": "Cevher çıkarır ve tüm ekonomiyi güçlendirir.",
  "building.barracks.name": "Kışla",
  "building.barracks.desc": "Savunmacılar eğitir, yerleşim savunmasını artırır.",
  "building.school.name": "Okul",
  "building.school.desc": "Bilgi üretir, teknolojiyi ve savunmayı ilerletir.",
  "resource.wood.name": "Odun",
  "resource.stone.name": "Taş",
  "resource.ore.name": "Maden",
  "resource.knowledge.name": "Bilgi",
  // Calamities (v0.10)
  "calamity.quake.name": "Deprem",
  "calamity.quake.desc": "Yerleşkenin altında toprak yarıldı. Ambarlar çatlaklara gömüldü.",
  "calamity.flood.name": "Büyük Sel",
  "calamity.flood.desc": "Nehir gece yükseldi ve istediğini alıp gitti.",
  "calamity.drought.name": "Kuraklık",
  "calamity.drought.desc": "Kuyular çekildi. Bembeyaz gökyüzünün altında her şey yavaşladı.",
  "calamity.plague.name": "Veba",
  "calamity.plague.desc": "Bir kervanla geldi ve kaldı. Şifacılar ellerinden geleni yaptı.",
  "calamity.great-fire.name": "Büyük Yangın",
  "calamity.great-fire.desc": "Bir ambarda başladı. Şafakta koca bir mahalle küldü.",
  "calamity.collapse.name": "Çöküş",
  "calamity.collapse.desc": "Büyük imar projesi çöktü. Ustalar birbirini suçluyor.",
  "calamity.market-crash.name": "Piyasa Çöküşü",
  "calamity.market-crash.desc": "Ganimet pazarı bir gecede battı. Kağıttan servetler, kağıttan küller.",
  "calamity.embargo.name": "Ticaret Ambargosu",
  "calamity.embargo.desc": "Yollar kapandı. Kervanlar, eskiden haritada çizgi olan sınırlarda bekliyor.",
  "calamity.unrest.name": "İç Karışıklık",
  "calamity.unrest.desc": "Meydandaki kalabalık slogan atmayı bıraktı, almaya başladı.",
  "calamity.exodus.name": "Büyük Göç",
  "calamity.exodus.desc": "Bir kervan gün doğmadan ayrıldı. Çadırlarını, sürülerini ve şüphelerini de götürdüler.",
};
